export const SUPPORTED_LANGUAGES = ['es', 'en', 'pt']

const MANUAL_LANGUAGE_KEY = 'language'
const MANUAL_LANGUAGE_FLAG = 'language-manual'

export function normalizeLanguageCode(code) {
  if (code == null || code === '') return null
  const base = String(code).trim().toLowerCase().split('-')[0]
  return SUPPORTED_LANGUAGES.includes(base) ? base : null
}

/** Idioma por defecto del sitio (concesionarias en español). */
export const DEFAULT_LANGUAGE = 'es'

/** Idioma preferido del navegador / sistema (navigator.languages). */
export function detectBrowserLanguage() {
  if (typeof navigator === 'undefined') return DEFAULT_LANGUAGE

  const candidates = [
    ...(Array.isArray(navigator.languages) ? navigator.languages : []),
    navigator.language,
    navigator.userLanguage,
  ].filter(Boolean)

  for (const candidate of candidates) {
    const resolved = normalizeLanguageCode(candidate)
    if (resolved) return resolved
  }

  return DEFAULT_LANGUAGE
}

function readManualLanguage() {
  try {
    if (localStorage.getItem(MANUAL_LANGUAGE_FLAG) !== 'true') return null
    return normalizeLanguageCode(localStorage.getItem(MANUAL_LANGUAGE_KEY))
  } catch {
    return null
  }
}

/** Idioma inicial: español por defecto; otra solo si el usuario eligió manualmente. */
export function getInitialLanguage() {
  return readManualLanguage() || DEFAULT_LANGUAGE
}

export function persistManualLanguage(code) {
  const normalized = normalizeLanguageCode(code)
  if (!normalized) return
  try {
    localStorage.setItem(MANUAL_LANGUAGE_KEY, normalized)
    localStorage.setItem(MANUAL_LANGUAGE_FLAG, 'true')
  } catch {
    /* ignore */
  }
}
